import {Button, IconButton} from '@wandb/components';
import _ from 'lodash';
import * as React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Checkbox, Divider, Label} from 'semantic-ui-react';

import type * as QueryTypes from '../../../util/queryTypes';
import * as Run from '../../../util/runs';
import * as UIHelpers from '../../../util/uihelpers';

interface WBTableActionGroupButtonProps {
  compact?: boolean;
  groupOpen: boolean;
  grouping: QueryTypes.Grouping;
  isInReport?: boolean;
  onPress: () => void;
}

export const WBTableActionGroupButton = (
  props: WBTableActionGroupButtonProps
) => {
  const groupCount = props.grouping.length;

  const {onPress} = props;

  const isActive = props.groupOpen || groupCount > 0;
  const buttonText =
    groupCount > 0
      ? 'Grouped by ' + UIHelpers.maybePluralize(groupCount, 'field')
      : 'Group';

  const handleAnalytics = () => {
    const actionLocation = props.isInReport ? 'report' : 'runs table';
    window.analytics?.track('Group dropdown clicked', {
      location: actionLocation,
    });
  };

  if (props.compact) {
    return (
      <IconButton
        icon="group"
        isActive={isActive}
        variant="secondary"
        tooltip={{children: buttonText}}
        data-test="group-button"
        aria-label={buttonText}
        onPress={() => {
          onPress();
          handleAnalytics();
        }}
      />
    );
  }
  return (
    <Button
      isActive={isActive}
      onPress={() => {
        onPress();
        handleAnalytics();
      }}
      startIcon="group"
      variant="secondary"
      data-test="group-button"
      aria-label={buttonText}>
      {buttonText}
    </Button>
  );
};

interface WBTableActionGroupPickerProps {
  grouping: QueryTypes.Grouping;
  recommendedGrouping?: QueryTypes.Grouping; // A good grouping for the current data
  dropdown: JSX.Element;

  setGrouping(grouping: QueryTypes.Grouping): void;
}

export const WBTableActionGroupPicker = (
  props: WBTableActionGroupPickerProps
) => {
  const {recommendedGrouping, grouping, dropdown, setGrouping} = props;

  return (
    <div>
      {dropdown}
      {recommendedGrouping != null && recommendedGrouping.length !== 0 && (
        <React.Fragment>
          <Divider />
          <div className="filter-list__toggle">
            <span style={{marginRight: 16, whiteSpace: 'nowrap'}}>
              Recommended:{' '}
              {recommendedGrouping.map((k, i) => (
                <Label key={i}>
                  {UIHelpers.getImage(k)} {Run.keyDisplayName(k, true)}
                </Label>
              ))}
            </span>
            <Checkbox
              className="filter-list__action"
              toggle
              checked={_.isEqual(grouping, recommendedGrouping)}
              onChange={() => {
                if (_.isEqual(grouping, recommendedGrouping)) {
                  setGrouping([]);
                } else {
                  setGrouping(recommendedGrouping);
                }
              }}
            />
          </div>
        </React.Fragment>
      )}
    </div>
  );
};
